module.exports = __webpack_public_path__ + "static/media/price.26787629.svg";